module.exports = __webpack_public_path__ + "static/media/icon-arrow-down.776690e6.svg";